import { EventEmitter } from '@angular/core';
var ReportListButtonComponent = (function () {
    function ReportListButtonComponent() {
        this.onSwitchReport = new EventEmitter();
    }
    ReportListButtonComponent.prototype.ngOnInit = function () {
        this.isExpand = false;
    };
    ReportListButtonComponent.prototype.ngOnChanges = function () {
        var reportsListLength = this.reports.length;
        for (var i = 0; i < reportsListLength; i++) {
            this.reports[i].nameHtml = this.reports[i].name.substr(0, 2) + '<br/>' + this.reports[i].name.substr(2, 3);
        }
    };
    ReportListButtonComponent.prototype.ngAfterViewInit = function () {
    };
    ReportListButtonComponent.prototype.onClick = function () {
        $(".casePracticeBtn").each(function (index) {
            this.style.transition = "top 0.5s";
        });
        if (this.isExpand) {
            $(".casePracticeBtn").each(function (index) {
                this.style.top = "0.3rem";
            });
        }
        else {
            $(".casePracticeBtn").each(function (index) {
                if (index == 0) {
                    this.style.top = "1.56rem";
                }
                else if (index == 1) {
                    this.style.top = "2.86rem";
                }
                else if (index == 2) {
                    this.style.top = "4.14rem";
                }
                else if (index == 3) {
                    this.style.top = "5.42rem";
                }
                else if (index == 4) {
                    this.style.top = "6.7rem";
                }
            });
        }
        this.isExpand = !this.isExpand;
    };
    ReportListButtonComponent.prototype.switchReport = function (id, type, index) {
        window.scrollTo(0, 0);
        //document.documentElement.scrollTop = 0;
        $(".casePracticeBtn").each(function (index) {
            this.style.transition = "top 0s";
        });
        this.onSwitchReport.emit({ id: id, type: type, index: index });
        $(".casePracticeBtn").each(function (index) {
            this.style.top = "0.3rem";
        });
        this.isExpand = !this.isExpand;
    };
    return ReportListButtonComponent;
}());
export { ReportListButtonComponent };



// WEBPACK FOOTER //
// ./src/app/report-list-button/report-list-button.component.ts.pre-build-optimizer.js